import { Component, OnInit, Input } from '@angular/core';
import { EntityInstanceNode } from "../entity-instance-node/EntityInstanceNode";

@Component({
  selector: 'app-entity-instance-register-editor',
  template: `<div class="schemaEditorBox">
  <div class="schemaEditorHeader">
    <h6 class="col-md-3">Entity Editor Box</h6>
     <div class="schemaEditorToolSection">
      <div class="schemaEditorToolSectionItem">
        <i class="fa fa-cloud-download schema-icon" title="Download JSON" (click)="downloJsonObject()"></i>
      </div>
    </div> 
  </div>

  <div class="root">
     <app-entity-instance-node   [propertyNode]="root"></app-entity-instance-node> 
  </div>
</div>`,
  styles: [`div.root{margin-top:5px;padding:5px;overflow-y:auto;height:400px}.schemaEditorToolSection{border-bottom:1px solid #e9ecef;width:100%;padding-top:5px;padding-right:18px}.schemaEditorToolSectionItem{float:right;margin-right:15px}.schemaEditorHeader{border-bottom:1px solid #e9ecef;display:-webkit-box;display:-ms-flexbox;display:flex}.schemaEditorHeader h6{padding:5px}.schemaEditorBox{border:1px solid #87ceeb;border-radius:9px;padding:9px;margin-top:13px}::-webkit-scrollbar{width:10px}::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px grey;box-shadow:inset 0 0 5px grey;border-radius:10px}::-webkit-scrollbar-thumb{background:#87ceeb;border-radius:10px}::-webkit-scrollbar-thumb:hover{background:#87ceeb}.schema-icon{font-size:25px}`]
})
export class EntityInstanceRegisterEditorComponent implements OnInit {
  @Input() root:EntityInstanceNode;   
  constructor() { }

  ngOnInit() {
    console.log(this.root);
  }
   downloJsonObject() {    
    var data = "data:text/json;charset=UTF-8," + encodeURIComponent(JSON.stringify(this.root.getEntityInstanceJson()));
    var downloader = document.createElement('a');

    downloader.setAttribute('href', data);
    downloader.setAttribute('download', 'file.json');
    downloader.click();
  } 
  FileChangeEvent(fileInput: any) {
    let CurrentFile = fileInput.target.files[0];

    let reader = new FileReader();

    reader.onload = () => {
      let jsonObj = JSON.parse(reader.result);
      this.root.importEntityInstanceNodeFromJsonObject(jsonObj);

    };
    reader.readAsText(CurrentFile);
    
  }

}
